import styled from "styled-components";

export const SSelectOrganizationStep = styled.div`
  width: 784px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
